<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height pa-0"
        fluid
        :style="`background-image: url('${backgroundImage}');background-position: center center; background-size: cover;`"
      >
        <v-col offset-sm="1" sm="10">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="5">
              <v-card class="elevation-12">
                <v-col class="d-flex justify-center pt-12">
                 <v-avatar size="400" max-height="60px" tile>
                    <v-img :src="logoImage" height="100%" contain />
                  </v-avatar>
                </v-col>

                <v-card-title class="d-flex justify-center pt-0">
                  <h5 class="text--disabled font-weight-light">
                    Cadastrar Senha
                  </h5>
                </v-card-title>
                <v-card-text>
                  <core-form
                    v-show="!msgResetError && validToken"
                    :submit="recuperarSenha"
                  >
                    <v-col class="pb-0">
                      <input-text
                        label="Usuário"
                        v-model="model.Login"
                        :disabled="true"
                      />
                    </v-col>
                    <v-col class="pb-0">
                      <input-text
                        label="Nova Senha"
                        :type="showPassword1 ? 'text' : 'password'"
                        required
                        :custom-rule="senhaValida" custom-error="Por favor, verifique as regras de senha"
                        v-model="model.NovaSenha"
                        :disabled="!model.Login"
                        :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                        @input="validarSenha"
                        @click:append="showPassword1 = !showPassword1"
                      />
                    </v-col>
                    <v-col class="py-0">
                      <input-text
                        label="Confirmar Senha"
                        :type="showPassword2 ? 'text' : 'password'"
                        required
                        v-model="confirmacaoSenha"
                        :custom-rule="confirmacaoSenha === model.NovaSenha" custom-error="Senhas não correspondem"
                        :disabled="!model.Login"
                        :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword2 = !showPassword2"
                      />
                    </v-col>
                    <v-col>
                      <p>* Senhas utilizadas nos últimos 12 meses não são válidas</p>
                      <ul class="ma-0 pa-0" >
                      <template v-for="(validation, key, index) in validations">
                        <span :key="index" >
                          <li class="d-flex justify-space-between">{{validation.message}}
                            <v-icon class="ml-2" :color="validation.test ? 'green':'red'" size="medium" icon="fas fa-exclamation-triangle">{{validation.test ? 'mdi-check':'mdi-close'}}
                            </v-icon>
                          </li>
                        </span>
                      </template>
                    </ul>
                    </v-col>

                    <v-col cols="12">
                      <v-btn
                        type="submit"
                        block
                        color="primary">Confirmar Senha</v-btn
                      >
                    </v-col>
                    <v-col cols="5">
                      <router-link
                        to="/"
                        class="font-weight-medium caption text-decoration-none"
                        >Voltar ao login</router-link
                      >
                    </v-col>
                  </core-form>

                  <v-col cols="12"  v-show="msgResetError" class="pt-0" style="min-height: 80px">
                    <v-alert type="error" class="mt-3 mb-0" text>
                      {{ msgResetError }}
                    </v-alert>
                    <br />
                    <router-link
                      to="/lembrar"
                      class="font-weight-medium caption text-decoration-none"
                      >Recuperação de senha</router-link
                    >
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  metaInfo: {
    title: 'Recuperação'
  },
  props: {
    logoImage: { type: String, default: require('shared/images/svg/logo-black.svg') },
    backgroundImage: {
      type: String,
      default: require('shared/images/svg/background.svg')
    }
  },
  data () {
    return {
      validations: {
        caractereEspecial: { test: false, message: '1 caractere especial' },
        letraMaiuscula: { test: false, message: '1 letra maiúscula' },
        letraMinuscula: { test: false, message: '1 letra minúscula' },
        numero: { test: false, message: '1 número' },
        caracteresUnicos: { test: false, message: '4 caracteres únicos' },
        extensaoMinima: { test: false, message: '8 caracteres no mínimo' }
      },
      model: { NovaSenha: '', Login: '', Token: '', CodigoUsuario: '' },
      confirmacaoSenha: '',
      msgResetError: '',
      showPassword1: false,
      showPassword2: false,
      validToken: false,
      passwordRules: [
        '<li>Documento Federal, ou partes dele</li>',
        '<li>Telefone, ou partes dele</li>',
        '<li>Data de nascimento, ou partes dela</li>',
        '<li>Sequências frágeis: abc, 1234, qwerty, entre outras</li>',
      ],
    }
  },
  methods: {
    recuperarSenha () {
      const th = this
      th.$api.Autenticacao.RecuperarSenha(th.model).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          th.$api.UI.Mensagem('info', 'Senha Redefinida! Faça login novamente.', function () {
            th.$router.push('/')
          })
        } else {
          th.$api.UI.Mensagem('alerta', 'Senha não pode conter: <br/><ul>' + th.passwordRules.join('') + '<ul/>')
        }
      }).catch((err) => console.log(err));
    },
    validaToken () {
      const th = this

      th.$api.Autenticacao.ValidaTokenSenha(th.model.Login, th.model.Token
      ).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          th.validToken = true
        } else {
          th.msgResetError =
            'O link para recuperação de senha expirou, é possível solicitar um novo link a partir da recuperação de senha'
        }
      })
    },
    validarSenha (senha) {
      const th = this;
      // eslint-disable-next-line
      const regexCaractereEspecial = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      const regexLetraMaiuscula = /\p{Lu}/u;
      const regexLetraMinuscula = /[\p{Ll}]/u;
      const regexNumero = /[0-9]/;
      const regexCaracteresUnicos = /^.*(?:(.)(?!.*\1)){4}/;

      th.validations.caractereEspecial.test = regexCaractereEspecial.test(senha)
      th.validations.letraMaiuscula.test = regexLetraMaiuscula.test(senha)
      th.validations.letraMinuscula.test = regexLetraMinuscula.test(senha)
      th.validations.numero.test = regexNumero.test(senha)
      th.validations.caracteresUnicos.test = regexCaracteresUnicos.test(senha)
      th.validations.extensaoMinima.test = senha.length >= 8
    }
  },
  computed: {
    senhaValida () {
      const th = this;
      return Object.values(th.validations).every(item => item.test === true)
    }
  },
  mounted: function () {
    const params = this.$route.query
    this.model.Login = params.e
    this.model.CodigoUsuario = params.c
    this.model.Token = params.t

    if (params.t) this.validaToken()
  },

}
</script>
